<!-- <h3><atlas-icon icon="lock" size="xxs" alt="Password lock"></atlas-icon> Reset Password</h3> -->
<h3><atlas-icon [icon]="'lock'" [size]="'small'" [alt]="'Password lock'"></atlas-icon> Reset Password</h3>

<div class="mos-u-spacer--padding-top-lg">
  <h4 class="mos-u-font-weight--medium">Please reset your password.</h4>
</div>
<form [formGroup]="form" (keyup.enter)="onReset()">
  <div class="row mos-o-form-row">
    <div class="small-12 columns mos-o-form-input-field mos-u-position--relative">
      <input haloPasswordRedaction [formControl]="form.get('password')" id="password-input" type="password"
        placeholder="Password" #pwRedactRef="haloPasswordRedaction">
      <div class="mos-u-position--absolute showHide" id="password-input-show-hide"
        (click)="pwRedactRef.toggleMaskField()">
        <atlas-icon [icon]="pwRedactRef.maskField ? 'icon-phone-24' : 'icon-mail-24'"></atlas-icon>
      </div>
    </div>
    <div class="small-12 columns password-validators">
      <div class="password-validators__item" [ngClass]="lengthValid ? 'valid' : 'invalid'">
        <atlas-icon [icon]="'icon-check-circle-24'" [collection]="'system'" [size]="'medium'"></atlas-icon>
        <span class="mos-u-spacer--margin-left-xxxxsm">8 characters</span>
      </div>
      <div class="password-validators__item" [ngClass]="caseValid ? 'valid' : 'invalid'">
        <atlas-icon [icon]="'icon-check-circle-24'" [collection]="'system'" [size]="'medium'"></atlas-icon>
        <span class="mos-u-spacer--margin-left-xxxxsm">At least one uppercase letter</span>
      </div>
      <div class="password-validators__item" [ngClass]="numberValid ? 'valid' : 'invalid'">
        <atlas-icon [icon]="'icon-check-circle-24'" [collection]="'system'" [size]="'medium'"></atlas-icon>
        <span class="mos-u-spacer--margin-left-xxxxsm">At least one number</span>
      </div>
      <div class="password-validators__item" [ngClass]="symbolValid ? 'valid' : 'invalid'">
        <atlas-icon [icon]="'icon-check-circle-24'" [collection]="'system'" [size]="'medium'"></atlas-icon>
        <span class="mos-u-spacer--margin-left-xxxxsm">At least one symbol</span>
      </div>
    </div>
  </div>
  <div class="row mos-u-spacer--padding-bottom-md">
    <div class="small-12 medium-5 columns">
      <atlas-button (click)="onReset()">Reset Password</atlas-button>

    </div>
  </div>
</form>